export default __webpack_public_path__ + "static/media/wn_7_4.465e865d.webp";